<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            @if (_context.mode !== FormMode.Reading) {
                <div class="mail-buttons">
                    <button
                        mat-mini-fab
                        class="basic-button"
                        aria-label="Ouvrir le carnet d’adresses"
                        matTooltip="Ouvrir le carnet d’adresses"
                        matTooltipPosition="below"
                        (click)="contacts()">
                        <mat-icon>contact_mail</mat-icon>
                    </button>

                    <button
                        mat-mini-fab
                        class="basic-button"
                        aria-label="Ajouter une pièce-jointe"
                        matTooltip="Ajouter une pièce-jointe"
                        matTooltipPosition="below"
                        (click)="fileToUpload.click()()">
                        <mat-icon>attach_file</mat-icon>
                    </button>
                </div>
            }
            <div class="top-container">
                <div class="left-container">
                    <input
                        ng2FileSelect
                        #fileToUpload
                        class="file-to-upload"
                        type="file"
                        [uploader]="uploader"
                        [hidden]="true"
                        multiple="multiple"
                        (onFileSelected)="onFileSelected($event)" />
                    <div class="form-item name form-item-help">
                        <mat-form-field class="with-info-icon">
                            <mat-label>Nom</mat-label>
                            <input matInput data-input-code type="text" formControlName="name" autocomplete="off" required />
                            @if (formGroupErrors?.name?.required && (formGroup.controls['name']?.dirty || formGroup.controls['name'].touched)) {
                                <mat-error data-input-title-error>Le champ 'Nom' est obligatoire</mat-error>
                            }
                        </mat-form-field>
                        <fa-icon
                            [icon]="faCircleInfo"
                            class="info-icon"
                            class="info-icon"
                            hubToolTip="Nom du modèle de mail. Ce nom sera affiché dans les listes déroulantes de selection d'un modèle de mail."
                            tooltipPosition="right"></fa-icon>
                    </div>
                    <div class="form-item form-item-help">
                        <mat-form-field class="with-info-icon mat-form-field-subject">
                            <mat-label>Objet</mat-label>
                            <input
                                matInput
                                [formControl]="subjectFormControl"
                                (keyup)="onChangeSubject($event)"
                                (contextmenu)="$event.preventDefault(); onInputRightClick('subject', $event)" />
                        </mat-form-field>
                        <fa-icon
                            [icon]="faCircleInfo"
                            class="info-icon"
                            class="info-icon"
                            hubToolTip="Ce champ permet de définir l'objet du mail."
                            tooltipPosition="right"></fa-icon>
                    </div>
                    <div class="form-item form-item-help">
                        <mat-form-field class="with-info-icon">
                            <mat-label>Emetteur</mat-label>
                            <mat-select
                                data-select-address
                                (selectionChange)="onSenderChange($event)"
                                [value]="email.fromAddressId"
                                [disabled]="_context.mode === FormMode.Reading">
                                <mat-option data-select-listing-type-option [value]="-1">Par défaut</mat-option>
                                @for (address of _context.addresses; track address) {
                                    <mat-option data-select-listing-type-option [value]="address.id">{{ address.displayName }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <fa-icon
                            [icon]="faCircleInfo"
                            class="info-icon"
                            hubToolTip="Ce champ permet de définir l'emetteur utilisé pour envoyer le mail.<br>Vous pouvez paramétrer un nouvel emetteur au niveau des adresses e-mails de l'organisation."
                            tooltipPosition="right"></fa-icon>
                    </div>
                    <div>
                        <div class="form-item form-item-help">
                            <mat-form-field class="with-info-icon mat-form-field-address">
                                <mat-label>Destinataires</mat-label>
                                <mat-chip-grid #toChipList [disabled]="_context.mode === FormMode.Reading" class="compact" [formControl]="addressToFormControl">
                                    @for (item of email.to; track item) {
                                        <mat-chip-row (removed)="removeAddress(item, AddressType.to)">
                                            {{ item }}
                                            @if (_context.mode !== FormMode.Reading) {
                                                <mat-icon matChipRemove>cancel</mat-icon>
                                            }
                                        </mat-chip-row>
                                    }
                                    <input
                                        [matChipInputFor]="toChipList"
                                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                        matChipInputAddOnBlur="true"
                                        (matChipInputTokenEnd)="addAddress($event, AddressType.to)"
                                        (contextmenu)="$event.preventDefault(); onChipListRightClick('to', $event)"
                                        placeholder="Saisir une adresse e-mail..." />
                                </mat-chip-grid>
                                @if (addressToFormControl.hasError('invalidFormat') && (addressToFormControl?.dirty || addressToFormControl?.touched)) {
                                    <mat-error>L'adresse mail est incorrecte</mat-error>
                                }
                            </mat-form-field>
                            <fa-icon
                                [icon]="faCircleInfo"
                                class="info-icon"
                                hubToolTip="Ce champ permet de définir les destinataires du mail.<br>Les adresses des destinataires peuvent être saisies manuellement ou en les sélectionnant à partir du carnet d'adresses.<br>
                            Pour valider la saisie d'une adresse e-mail manuelle, cliquez sur <b>;</b> ou sur <b>Entrée</b>.<br><br>Il est également possible d'utiliser une <b>variable</b> faisant référence à un attribut de type <b>e-mail</b>. Cette variable sera remplacée par la valeur de l'attribut correspondant au moment de l'envoi du mail.<br>Pour ajouter une variable, faites un clic droit sur le champ pour afficher la liste des variables disponibles."
                                tooltipPosition="right"></fa-icon>
                        </div>
                    </div>

                    <div>
                        <div class="form-item form-item-help">
                            <mat-form-field class="with-info-icon mat-form-field-address">
                                <mat-label>Cc</mat-label>
                                <mat-chip-grid #ccChipList [formControl]="addressCcFormControl" [disabled]="_context.mode === FormMode.Reading" class="compact">
                                    @for (item of email.cc; track item) {
                                        <mat-chip-row (removed)="removeAddress(item, AddressType.cc)">
                                            {{ item }}
                                            @if (_context.mode !== FormMode.Reading) {
                                                <mat-icon matChipRemove>cancel</mat-icon>
                                            }
                                        </mat-chip-row>
                                    }
                                    <input
                                        [matChipInputFor]="ccChipList"
                                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                        matChipInputAddOnBlur="true"
                                        (matChipInputTokenEnd)="addAddress($event, AddressType.cc)"
                                        (contextmenu)="$event.preventDefault(); onChipListRightClick('cc', $event)"
                                        placeholder="Saisir une adresse e-mail..." />
                                </mat-chip-grid>
                                @if (addressCcFormControl.hasError('invalidFormat') && (addressCcFormControl?.dirty || addressCcFormControl?.touched)) {
                                    <mat-error>L'adresse email est incorrecte</mat-error>
                                }
                            </mat-form-field>
                            <fa-icon
                                [icon]="faCircleInfo"
                                class="info-icon"
                                class="info-icon"
                                hubToolTip="Ce champ permet de définir les destinataires en copie carbone (Cc) du mail.<br>Les adresses des destinataires en copie carbone peuvent être saisies manuellement ou en les sélectionnant à partir du carnet d'adresses.<br>
                            Pour valider la saisie d'une adresse e-mail manuelle, cliquez sur <b>;</b> ou sur <b>Entrée</b>.<br><br>Il est également possible d'utiliser une <b>variable</b> faisant référence à un attribut de type <b>e-mail</b>. Cette variable sera remplacée par la valeur de l'attribut correspondant au moment de l'envoi du mail.<br>Pour ajouter une variable, faites un clic droit sur le champ pour afficher la liste des variables disponibles."
                                tooltipPosition="right">
                                >
                            </fa-icon>
                        </div>
                    </div>
                    <div>
                        <div class="form-item form-item-help">
                            <mat-form-field class="with-info-icon mat-form-field-address">
                                <mat-label>Cci</mat-label>
                                <mat-chip-grid #cciChipList [formControl]="addressCciFormControl" [disabled]="_context.mode === FormMode.Reading" class="compact">
                                    @for (item of email.cci; track item) {
                                        <mat-chip-row (removed)="removeAddress(item, AddressType.cci)">
                                            {{ item }}
                                            @if (_context.mode !== FormMode.Reading) {
                                                <mat-icon matChipRemove>cancel</mat-icon>
                                            }
                                        </mat-chip-row>
                                    }
                                    <input
                                        [matChipInputFor]="cciChipList"
                                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                        matChipInputAddOnBlur="true"
                                        (matChipInputTokenEnd)="addAddress($event, AddressType.cci)"
                                        (contextmenu)="$event.preventDefault(); onChipListRightClick('cci', $event)"
                                        placeholder="Saisir une adresse e-mail..." />
                                </mat-chip-grid>
                                @if (addressCciFormControl.hasError('invalidFormat') && (addressCciFormControl?.dirty || addressCciFormControl?.touched)) {
                                    <mat-error>L'adresse email est incorrecte</mat-error>
                                }
                            </mat-form-field>
                            <fa-icon
                                [icon]="faCircleInfo"
                                class="info-icon"
                                class="info-icon"
                                hubToolTip="Ce champ permet de définir les destinataires en copie carbone invisible (Cci) du mail.<br>Les adresses des destinataires en copie carbone invisible peuvent être saisies manuellement ou en les sélectionnant à partir du carnet d'adresses.<br>
                            Pour valider la saisie d'une adresse e-mail manuelle, cliquez sur <b>;</b> ou sur <b>Entrée</b>.<br><br>Il est également possible d'utiliser une <b>variable</b> faisant référence à un attribut de type <b>e-mail</b>. Cette variable sera remplacée par la valeur de l'attribut correspondant au moment de l'envoi du mail.<br>Pour ajouter une variable, faites un clic droit sur le champ pour afficher la liste des variables disponibles."
                                tooltipPosition="right"></fa-icon>
                        </div>
                    </div>
                </div>
                <div class="right-container">
                    <div class="message">
                        <div class="message-header">
                            <p class="body-placeholder">Message</p>
                            <fa-icon
                                [icon]="faCircleInfo"
                                class="info-icon"
                                hubToolTip="Ce champ permet de définir le contenu du mail.<br>Il est possible d'utiliser des <b>variables</b> faisant référence à des attributs du dossier. Ces variables seront remplacées par la valeur de l'attribut correspondant au moment de l'envoi du mail.<br>Pour ajouter une variable, faites un clic droit sur le champ pour afficher la liste des variables disponibles."
                                tooltipPosition="right"></fa-icon>
                        </div>

                        @if (_context.mode !== FormMode.Reading) {
                            <angular-editor
                                [config]="edit_config"
                                [formControl]="bodyFormControl"
                                (keyup)="onChangeBody()"
                                (contextmenu)="$event.preventDefault(); onBodyRightClick($event)">
                                <!--(contextmenu)="onBodyRightClick($event)" -->
                            </angular-editor>
                        } @else {
                            <angular-editor [config]="read_config" [formControl]="bodyFormControl"></angular-editor>
                        }

                        <app-template-context-menu
                            [ngStyle]="getContextMenuStyle()"
                            [contextMenuItems]="contextMenuItems"
                            (onContextMenuItemClick)="handleMenuItemClick($event)"
                            (onClosed)="CloseContextMenu()"></app-template-context-menu>
                    </div>
                </div>
            </div>
            <div class="attachments-container">
                <div class="attachments-header">
                    <p class="attachments-placeholder">Pièces-jointes</p>
                    <fa-icon
                        [icon]="faCircleInfo"
                        class="info-icon"
                        hubToolTip=" Ce champ permet de définir les pièces-jointes du mail.<br>Il est possible d'ajouter des pièces-jointes en les sélectionnant à partir de votre ordinateur.<br>Pour ajouter une pièce-jointe, cliquez sur l'icône représentant un trombone dans le coin supérieur droit."
                        tooltipPosition="right"></fa-icon>
                </div>

                @if (uploader.queue.length !== 0 || email?.predefinedAttachments?.length !== 0) {
                    <table class="table-add-file">
                        <thead>
                            <tr>
                                <th width="570px">Nom du fichier</th>
                                <th width="100px">Taille du fichier</th>
                                @if (_context.mode !== FormMode.Reading) {
                                    <th>Action</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            @for (item of uploader.queue; track item) {
                                <tr>
                                    <td width="570px">{{ item?.file?.name }}</td>
                                    <td width="100px">{{ item?.file?.size | avmFileSize }}</td>
                                    <td>
                                        <mat-icon (click)="item.remove()">delete</mat-icon>
                                    </td>
                                </tr>
                            }
                            @for (item of email?.predefinedAttachments; track item) {
                                <tr>
                                    <td width="570px">{{ item?.name }}</td>
                                    <td width="100px">{{ item?.size | avmFileSize }}</td>
                                    @if (_context.mode !== FormMode.Reading) {
                                        <td>
                                            <mat-icon (click)="removePredefinedAttachment(item?.id)">delete</mat-icon>
                                        </td>
                                    }
                                </tr>
                            }
                        </tbody>
                    </table>
                } @else {
                    <p>Aucune pièce-jointe</p>
                }
            </div>
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }" (click)="cancel()">
            Annuler
        </button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid || toAddressIsInvalid || ccAddressIsInvalid || cciAddressIsInvalid"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
